module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "userPanel"
  }, [(!_vm.isLogged) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_vm._v("Войти")]) : _vm._e(), _vm._v(" "), (_vm.isLogged) ? _c('div', {
    staticStyle: {
      "position": "relative",
      "text-align": "center"
    },
    on: {
      "mouseover": function($event) {
        _vm.showMenu = true
      },
      "mouseout": function($event) {
        _vm.showMenu = false
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.shortName) + "\n        "), _c('div', {
    staticClass: "logout"
  }, [_c('button', {
    staticClass: "btn-link",
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fi-close"
  }), _vm._v(" Выйти")])]), _vm._v(" "), (0) ? _c('div', {
    attrs: {
      "id": "userMenu"
    }
  }, [_c('ul', {
    staticClass: "vertical menu"
  }, [_c('li', [_vm._v(_vm._s(_vm.user.login))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.date(_vm.user.iat)))]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fi-close"
  }), _vm._v(" Выйти")])])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Настройки")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d4e5d3ac","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserPanel.vue
// module id = 118
// module chunks = 0